export * as queries from './queries'
export * as mutations from './mutations'
export * as inputs from './inputs'
export * as fragments from './fragments'
